import { Box, Divider } from "@mui/material";
import type { PortalWidget, PortalWidgetSettings } from "@entrilia/shared/api/portalWidgetsTypes";
import type {
  InvestorPortalFeature,
  InvestorPortalSettings,
  InvestorPortalSettingsResponse,
} from "../../../../api/types/investorPortalTypes";
import type { ReportInfo } from "../../../../api/types/svTypes";
import { getPageStatusFromPortalSettings, type PortalPageStatus } from "../pages/portalPageStatusHelper";
import PortalWidgetEditor from "./PortalWidgetEditor";
import PortalWidgetPageSettings from "./PortalWidgetPageSettings";
import { getWidgetPageStatus } from "./portalWidgetsHelper";

interface Props {
  page: InvestorPortalFeature;
  pageStatus: PortalPageStatus;
  portalSettings: InvestorPortalSettings;
  selectedWidget: PortalWidget | undefined;
  systemReports: ReportInfo[];
  hasReportsViewPermissions: boolean;
  hasReportsEditPermissions: boolean;
  onWidgetUpdated: (updatedSettings: PortalWidgetSettings) => void;
  onPortalSettingsUpdated: (updated: InvestorPortalSettingsResponse) => void;
  onDeselectWidget: () => void;
}

const PortalWidgetDetailsSection = ({
  page,
  pageStatus,
  portalSettings,
  selectedWidget,
  systemReports,
  hasReportsViewPermissions,
  hasReportsEditPermissions,
  onWidgetUpdated,
  onPortalSettingsUpdated,
  onDeselectWidget,
}: Props) => {
  return (
    <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
      <Divider orientation="vertical" flexItem />
      {selectedWidget ? (
        <PortalWidgetEditor
          key={selectedWidget.id}
          widget={selectedWidget}
          pageStatus={getWidgetPageStatus(
            selectedWidget,
            pageStatus,
            getPageStatusFromPortalSettings("News", portalSettings)
          )}
          systemReports={systemReports}
          hasReportsViewPermissions={hasReportsViewPermissions}
          hasReportsEditPermissions={hasReportsEditPermissions}
          onWidgetUpdated={onWidgetUpdated}
          onDeselectWidget={onDeselectWidget}
        />
      ) : (
        <PortalWidgetPageSettings
          page={page}
          pageStatus={pageStatus}
          portalSettings={portalSettings}
          onPortalSettingsUpdated={onPortalSettingsUpdated}
        />
      )}
    </Box>
  );
};

export default PortalWidgetDetailsSection;
